const getWidth = (col) => {
  switch (col?.name) {
    default:
      return 150;
  }
};

const getAttributeName = (col) => {
  switch (col?.name) {
    default:
      return col?.name;
  }
};

const getType = (col) => {
  switch (col?.name) {
    case 'assetAge':
      return 'AssetAge';
    case 'comments':
      return 'Comments';
    case 'type':
      switch (col?.accessor) {
        case 'surveytype':
          return 'SurveyType';
        default:
          return 'PLAIN';
      }
    default:
      return col?.dataReportRenderType || 'PLAIN';
  }
};

const getModuleName = (mod, entity) => {
  switch (true) {
    case mod == 'user' && entity == 'RequesterAssociation':
      return 'clientuser';
    default:
      return mod;
  }
};

const getAccessor = (col) => {
  switch (col?.accessor) {
    default:
      return col?.accessor;
  }
};

export { getWidth, getAttributeName, getType, getAccessor, getModuleName };
